"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var eligibility_1 = require("@bhtp-client-api/eligibility");
var ng2_bs3_modal_1 = require("@bhtp-fork/ng2-bs3-modal/ng2-bs3-modal");
var modal_service_1 = require("./modal.service");
var view_models_1 = require("./../../view-models");
var ApiMessageModalComponent = (function () {
    function ApiMessageModalComponent(modalService, eligiblityService) {
        this.modalService = modalService;
        this.eligiblityService = eligiblityService;
    }
    ApiMessageModalComponent.prototype.ngOnInit = function () {
        this.onCloseModal(false);
        this.modalService.registerApiMessageModalComponent(this);
    };
    ApiMessageModalComponent.prototype.ngOnDestroy = function () {
        this.onCloseModal(false);
    };
    ApiMessageModalComponent.prototype.open = function (options) {
        var _this = this;
        this.clearModalData();
        this.modalOptions = options;
        this.title = options.title;
        this.messages = options.apiErrorMessages;
        if (options.continueButtonText && options.continueButtonText.trim().length > 0) {
            this.continueButtonText = options.continueButtonText;
        }
        if (options.notificationMessage) {
            this.formattedNotificationMessage = this.formatDisplayMessage(options.notificationMessage);
        }
        if (this.messages) {
            // check for any product swap recommendations
            var recommendation_1 = eligibility_1.BhtpEligibilityService.getRecommendationMessage(this.messages);
            if (recommendation_1) {
                this.swapRatingId = eligibility_1.BhtpEligibilityService.parseRecommendationCode(recommendation_1);
                if (this.swapRatingId) {
                    if (options.availablePackages) {
                        // if there is a product to swap, give user the option to
                        // swap the rating id
                        var swapPackage = options.availablePackages.find(function (p) { return p.ratingId === _this.swapRatingId; });
                        if (swapPackage) {
                            var title = swapPackage.displayName;
                            if (swapPackage.displayNameSubtitle) {
                                title = title + " " + swapPackage.displayNameSubtitle;
                            }
                            this.buttonAreaPromptMessage = "Would you like to switch to " + title + "?";
                            this.cancelButtonText = 'NO';
                            this.continueButtonText = 'YES';
                        }
                    }
                    // remove the recommendation message so it doesn't display
                    this.messages.splice(this.messages.findIndex(function (m) { return m.code === recommendation_1.code; }), 1);
                }
            }
        }
        if (!this.modal.visible) {
            this.modal.open();
        }
        return this.modal.onClose.asObservable();
    };
    ApiMessageModalComponent.prototype.onContinueClicked = function (event) {
        if (this.modalOptions.acknowledgementsAcceptedCallback) {
            // pass the accepted acknowledgements into the callback method, if there are any.
            if (this.acceptedAcknowledgements && this.acceptedAcknowledgements.length > 0) {
                this.modalOptions.acknowledgementsAcceptedCallback(this.acceptedAcknowledgements);
            }
        }
        this.onCloseModal(true);
    };
    ApiMessageModalComponent.prototype.onCloseModal = function (continueClicked) {
        if (this.modal) {
            var response = new view_models_1.ApiMessageModalResponse();
            if (this.acceptedAcknowledgements) {
                response.acknowledgementsWereAccepted = this.acceptedAcknowledgements.length > 0;
                response.acceptedAcknowledgements = this.acceptedAcknowledgements;
            }
            response.continueButtonWasClicked = continueClicked;
            response.ratingIdToSwap = continueClicked ? this.swapRatingId : null;
            this.modal.close(response);
        }
    };
    ApiMessageModalComponent.prototype.clearModalData = function () {
        // there is a single instance of this component,
        // so clear data for the next use
        this.modalOptions = null;
        this.acceptedAcknowledgements = [];
        this.title = null;
        this.messages = [];
        this.formattedNotificationMessage = null;
        this.buttonAreaPromptMessage = null;
        this.cancelButtonText = null;
        this.continueButtonText = 'Continue';
        this.swapRatingId = null;
    };
    ApiMessageModalComponent.prototype.onAcknowledgementAccepted = function (acceptedAcknowledgement) {
        // add this acknowledgement to the list of accepted acknowledgements.
        this.acceptedAcknowledgements.push(acceptedAcknowledgement);
    };
    ApiMessageModalComponent.prototype.onAcknowledgementUnaccepted = function (unacceptedAcknowledgement) {
        // remove this acknowledgement from the list of accepted acknowledgements, if it was found.
        var indexOfAckToRemove = this.acceptedAcknowledgements.indexOf(unacceptedAcknowledgement);
        if (indexOfAckToRemove > -1) {
            this.acceptedAcknowledgements.splice(indexOfAckToRemove, 1);
        }
    };
    ApiMessageModalComponent.prototype.hasAcknowledgements = function (message) {
        return message && message.acknowledgements && message.acknowledgements.length > 0;
    };
    ApiMessageModalComponent.prototype.formatDisplayMessage = function (message) {
        // replace any newline chars here with br tags.
        return message ? message.replace(/\\n/gi, '<br />') : '';
    };
    return ApiMessageModalComponent;
}());
__decorate([
    core_1.ViewChild('messageModal'),
    __metadata("design:type", ng2_bs3_modal_1.ModalComponent)
], ApiMessageModalComponent.prototype, "modal", void 0);
ApiMessageModalComponent = __decorate([
    core_1.Component({
        selector: 'api-message-modal',
        template: "<modal #messageModal class=\"panel-primary\">     <div class=\"modal-heading\" style=\"border-top-left-radius: 4px; border-top-right-radius: 4px;\">         <modal-header [show-close]=\"true\">             <h4 class=\"modal-title\">{{title}}</h4>         </modal-header>     </div>     <modal-body>         <div *ngIf=\"messages\">             <div *ngFor=\"let message of messages\">                 <error-message-display *ngIf=\"!hasAcknowledgements(message)\"                                         [message]=\"message.text\">                 </error-message-display>                 <div *ngIf=\"hasAcknowledgements(message)\">                     <acknowledgement-selector *ngFor=\"let ack of message.acknowledgements\"                                               [acknowledgement]=\"ack\"                                               (acknowledgementAccepted)=\"onAcknowledgementAccepted($event)\"                                               (acknowledgementUnaccepted)=\"onAcknowledgementUnaccepted($event)\">                     </acknowledgement-selector>                 </div>             </div>         </div>         <div *ngIf=\"formattedNotificationMessage\" [innerHTML]=\"formattedNotificationMessage\"></div>      </modal-body>     <modal-footer>         <div class=\"button-area-prompt\" *ngIf=\"buttonAreaPromptMessage\">             {{ buttonAreaPromptMessage }}         </div>         <button type=\"button\" *ngIf=\"cancelButtonText\" class=\"btn btn-default btn-cust\" (click)=\"onCloseModal(false)\">             {{ cancelButtonText }}         </button>         <button type=\"button\" class=\"btn btn-default btn-cust\" (click)=\"onContinueClicked($event)\">             {{ continueButtonText }}         </button>      </modal-footer> </modal>",
    }),
    __metadata("design:paramtypes", [modal_service_1.ModalService, eligibility_1.BhtpEligibilityService])
], ApiMessageModalComponent);
exports.ApiMessageModalComponent = ApiMessageModalComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/misc/modals/api-message-modal.component.js